import { useEffect, useState } from 'react';

export default function useAvailableProjects(apiClient, authenticatedUser) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(Boolean(apiClient && authenticatedUser));
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function loadProjects() {
      if (!apiClient || !authenticatedUser) {
        setProjects([]);
        setLoading(false);
        setError(null);
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const data = await apiClient.getProjects();
        if (!cancelled) {
          setProjects(Array.isArray(data) ? data : []);
        }
      } catch (err) {
        if (!cancelled) {
          setProjects([]);
          setError(err?.message || 'Failed to load projects');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadProjects();
    return () => {
      cancelled = true;
    };
  }, [apiClient, authenticatedUser]);

  return {
    projects,
    loading,
    error,
    hasMultipleProjects: projects.length > 1,
  };
}
